/**
 * 2.3 theme-only cart extras. No Vue. No custom-checkout cart validation.
 * - AD_ "add N more" prompts from product tags
 * - Discount codes via POST /cart/update.js { discount }
 *   Badge for unused real codes (TĪRS) uses _emk_discount_code, but only after
 *   POST /discount-code-validation confirms the code exists and is ACTIVE.
 * - Service fee €1.99 when goods (after discounts, fee excluded) are under €25
 *   Checkout click re-syncs (same intercept as terms) and collapses a double-add.
 * - Warranty: hidden Garantija variant via warranty.variant_id metafield
 *
 * Do not observe #mini-cart and rewrite it in the same turn: that hung the
 * storefront (MutationObserver → innerHTML → observer → …). Re-run only after
 * Warehouse finishes a cart section render (theme:loading:end).
 */
(function () {
  var AD_RE = /^AD_B(\d+)(PD|FP|FD)(\d+)_(.+)$/;

  // Clarity is on theme.liquid (hqb39s7bds). Storefront only — not checkout/accounts.
  function clarityEvent(name) {
    if (!name) return;
    try {
      if (typeof window.clarity === "function") window.clarity("event", name);
    } catch (err) {}
  }

  // Sticky bar is outside the header section. Warehouse only listens inside
  // header, then treats this bar as an outside click and closes drawers.
  // Window capture runs before the theme's <html> capture, so we can stop
  // that and forward to the real header controls.
  window.addEventListener(
    "click",
    function (event) {
      var cartTab = event.target.closest && event.target.closest("#minicart-mobile-popup");
      var menuTab = event.target.closest && event.target.closest("#mobile-menu-toggle");
      var searchTab = event.target.closest && event.target.closest("#sticky-nav-wrap-2 [data-action='toggle-search']");
      if (!cartTab && !menuTab && !searchTab) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (cartTab) {
        var headerCart = document.querySelector('.header__cart-toggle[data-action="toggle-mini-cart"]');
        if (headerCart) headerCart.click();
        else window.location.href = "/cart";
        return;
      }
      if (menuTab) {
        var headerMenu = document.querySelector('.header__mobile-nav-toggle[data-action="toggle-menu"]');
        if (headerMenu) headerMenu.click();
        return;
      }
      var headerSearch = document.querySelector('.header [data-action="toggle-search"]');
      if (headerSearch) headerSearch.click();
    },
    true
  );

  window.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    var tab = event.target.closest && event.target.closest("#minicart-mobile-popup, #mobile-menu-toggle");
    if (!tab) return;
    event.preventDefault();
    tab.click();
  });

  function syncStickyMenuIcons() {
    var headerMenu = document.querySelector(".header__mobile-nav-toggle");
    var sticky = document.getElementById("mobile-menu-toggle");
    if (!headerMenu || !sticky) return;
    var open = headerMenu.getAttribute("aria-expanded") === "true";
    var menuIcon = sticky.querySelector("#Menu_Icon");
    var closeIcon = sticky.querySelector("#Close_Icon");
    if (menuIcon) menuIcon.style.display = open ? "none" : "";
    if (closeIcon) closeIcon.style.display = open ? "" : "none";
    sticky.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function watchStickyMenu() {
    var headerMenu = document.querySelector(".header__mobile-nav-toggle");
    if (!headerMenu || headerMenu.getAttribute("data-emk-sticky-watched")) return;
    headerMenu.setAttribute("data-emk-sticky-watched", "1");
    if (window.MutationObserver) {
      new MutationObserver(syncStickyMenuIcons).observe(headerMenu, {
        attributes: true,
        attributeFilter: ["aria-expanded"]
      });
    }
    syncStickyMenuIcons();
  }

  function moneyFromCents(cents) {
    return (Math.max(0, cents) / 100).toFixed(2).replace(".", ",");
  }

  function parseAdPayload() {
    var node = document.querySelector("[data-cart-ad]");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function parseTag(tag) {
    if (!tag) return null;
    var match = String(tag).match(AD_RE);
    if (!match) return null;
    return {
      buy: parseInt(match[1], 10),
      kind: match[2],
      value: parseInt(match[3], 10),
      group: match[4],
      tag: tag
    };
  }

  function savingsCents(rule, unitPrice) {
    if (rule.kind === "PD") return Math.round((rule.buy * unitPrice * rule.value) / 100);
    if (rule.kind === "FP") return Math.round(rule.buy * (unitPrice - rule.value));
    if (rule.kind === "FD") return rule.buy * rule.value;
    return 0;
  }

  function promptHtml(payload, line, missing, save) {
    var addText = (payload.i18n.add_one || "Pievieno vēl __N__").replace("__N__", String(missing));
    var saveKey = missing === 1 ? "save_one" : "save_many";
    var saveText = (payload.i18n[saveKey] || "ietaupi __S__ €").replace("__S__", save);
    return (
      '<button type="button" class="cart-line-extras__ad-add link" data-action="ad-add" data-line="' +
      line.line +
      '" data-add="' +
      missing +
      '">' +
      addText +
      "</button> " +
      saveText
    );
  }

  function renderAdPrompts() {
    var payload = parseAdPayload();
    var slots = document.querySelectorAll("[data-ad-line]");
    if (!slots.length) return;

    var htmlByLine = {};
    if (payload && payload.lines) {
      var groups = {};
      // Products a store discount already applies to (e.g. automatic "ILC 2+1" with its free line): no "Pievieno vēl"
      var discounted = {};
      payload.lines.forEach(function (line) {
        if (line.disc > 0 || !(line.price > 0)) discounted[line.product] = true;
      });
      payload.lines.forEach(function (line) {
        if (!(line.price > 0)) return; // free lines (gifts, 100% off): no "Pievieno vēl" and not counted in the deal
        if (line.product && discounted[line.product]) return; // deal already applied (2+1 …)
        (line.tags || []).forEach(function (tag) {
          var rule = parseTag(tag);
          if (!rule) return;
          if (!groups[rule.group]) {
            groups[rule.group] = { rule: rule, qty: 0, lines: [] };
          }
          groups[rule.group].qty += line.qty;
          groups[rule.group].lines.push(line);
        });
      });

      Object.keys(groups).forEach(function (group) {
        var entry = groups[group];
        var missing = entry.rule.buy - entry.qty;
        if (missing <= 0) return;
        entry.lines.forEach(function (line) {
          if (htmlByLine[line.line]) return;
          htmlByLine[line.line] = promptHtml(
            payload,
            line,
            missing,
            moneyFromCents(savingsCents(entry.rule, line.price))
          );
        });
      });
    }

    slots.forEach(function (slot) {
      var html = htmlByLine[slot.getAttribute("data-ad-line")] || "";
      if (slot.innerHTML === html && slot.hidden === !html) return;
      slot.hidden = !html;
      slot.innerHTML = html;
    });
  }

  function blockCheckoutIfOversold() {
    var blocked = document.querySelector("[data-cart-stock-block]");
    document.querySelectorAll('[name="checkout"]').forEach(function (button) {
      var next = Boolean(blocked);
      if (button.disabled === next && button.classList.contains("is-disabled") === next) return;
      button.disabled = next;
      button.classList.toggle("is-disabled", next);
    });
  }

  var TERMS_KEY = "emk_cart_terms";

  function termsRoot(node) {
    return node && node.closest ? node.closest("[data-cart-terms]") : null;
  }

  function termsAccepted(root) {
    var input = root && root.querySelector("[data-cart-terms-input]");
    return Boolean(input && input.checked);
  }

  function showTermsError(root) {
    if (!root) return;
    var el = root.querySelector("[data-cart-terms-error]");
    root.classList.add("is-error");
    if (!el) return;
    el.hidden = false;
    el.textContent = root.getAttribute("data-required") || "";
  }

  function hideTermsError(root) {
    if (!root) return;
    var el = root.querySelector("[data-cart-terms-error]");
    root.classList.remove("is-error");
    if (!el) return;
    el.hidden = true;
    el.textContent = "";
  }

  function persistTerms(checked) {
    try {
      if (checked) sessionStorage.setItem(TERMS_KEY, "1");
      else sessionStorage.removeItem(TERMS_KEY);
    } catch (err) {}
  }

  function restoreTerms() {
    var saved = false;
    try {
      saved = sessionStorage.getItem(TERMS_KEY) === "1";
    } catch (err) {}
    document.querySelectorAll("[data-cart-terms]").forEach(function (root) {
      var input = root.querySelector("[data-cart-terms-input]");
      if (!input) return;
      if (input.checked !== saved) input.checked = saved;
      if (saved) hideTermsError(root);
    });
  }

  function blockCheckoutWithoutTerms(event, form) {
    var root = form && form.querySelector("[data-cart-terms]");
    if (!root) return false;
    if (termsAccepted(root)) {
      hideTermsError(root);
      return false;
    }
    event.preventDefault();
    event.stopPropagation();
    showTermsError(root);
    clarityEvent("terms_blocked");
    return true;
  }

  var cartBusy = false;
  var checkoutBusy = false;
  var checkoutLeaving = false;
  var feeSyncTail = Promise.resolve();
  var pdpWarrantyPreAdded = false;

  function parseFeeConfig() {
    var node = document.querySelector("[data-cart-fee]");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function addCartItem(payload) {
    return fetch(cartRoot() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) throw new Error(body.description || body.message || "cart add failed");
        return body;
      });
    });
  }

  function addFeeVariant(variantId) {
    return addCartItem({
      id: Number(variantId),
      quantity: 1,
      properties: { _service_fee: "1" }
    });
  }

  function feeIsLast(cart) {
    var items = cart.items || [];
    if (!items.length) return true;
    return isFeeItem(items[items.length - 1]);
  }

  function goodsPayloads(cart) {
    var rows = [];
    (cart.items || []).forEach(function (item) {
      if (isFeeItem(item)) return;
      var payload = {
        id: Number(item.variant_id),
        quantity: Number(item.quantity) || 1
      };
      var props = item.properties;
      if (props) {
        var clean = {};
        var has = false;
        Object.keys(props).forEach(function (key) {
          if (props[key] == null || props[key] === "") return;
          clean[key] = String(props[key]);
          has = true;
        });
        if (has) payload.properties = clean;
      }
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      if (plan && plan.id) payload.selling_plan = plan.id;
      rows.push({ key: item.key, payload: payload });
    });
    return rows;
  }

  function queueCartWork(items, worker) {
    return items.reduce(function (chain, item) {
      return chain.then(function () {
        return worker(item);
      });
    }, Promise.resolve());
  }

  // cart.js is newest-first. Adding the fee last would put it at the top of
  // native checkout. Re-add goods on top so the fee stays the oldest line.
  function ensureFeeLast(cart) {
    if (feeIsLast(cart)) return Promise.resolve(cart);
    var rows = goodsPayloads(cart);
    if (!rows.length) return Promise.resolve(cart);
    return queueCartWork(rows, function (row) {
      return changeLineByKey(row.key, 0);
    }).then(function () {
      return queueCartWork(rows.slice().reverse(), function (row) {
        return addCartItem(row.payload);
      });
    }).then(fetchCart);
  }

  function isFeeItem(item) {
    return item.handle === "apkalposanas-maksa" || (item.properties && item.properties._service_fee);
  }

  function isWarrantyItem(item) {
    return item.handle === "garantija" || (item.properties && item.properties._warranty_for);
  }

  function itemProp(item, key) {
    return item.properties ? item.properties[key] : "";
  }

  function fetchCart() {
    return fetch(cartRoot() + "cart.js", {
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("cart fetch failed");
      return response.json();
    });
  }

  function changeLineByKey(key, qty) {
    return fetch(cartRoot() + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Number(qty) })
    }).then(function (response) {
      if (!response.ok) throw new Error("cart change failed");
      return response.json();
    });
  }

  function parentVariantToken(parent) {
    return String(parent.variant_id);
  }

  function findParentByVariant(cart, variantId) {
    var items = cart.items || [];
    var match = null;
    for (var i = 0; i < items.length; i++) {
      if (isWarrantyItem(items[i]) || isFeeItem(items[i])) continue;
      if (Number(items[i].variant_id) === Number(variantId)) match = items[i];
    }
    return match;
  }

  function findParentForWarranty(cart, warrantyItem) {
    var token = itemProp(warrantyItem, "_warranty_for") || itemProp(warrantyItem, "_warranty_parent_variant");
    if (!token) return null;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (isWarrantyItem(items[i]) || isFeeItem(items[i])) continue;
      if (items[i].key === token || String(items[i].variant_id) === String(token)) return items[i];
    }
    return null;
  }

  function findWarrantyFor(cart, parent) {
    var items = cart.items || [];
    var key = parent.key;
    var vid = parentVariantToken(parent);
    for (var i = 0; i < items.length; i++) {
      if (!isWarrantyItem(items[i])) continue;
      var token = itemProp(items[i], "_warranty_for") || itemProp(items[i], "_warranty_parent_variant");
      if (token === key || token === vid) return items[i];
    }
    return null;
  }

  function warrantyProperties(spec, parentVariantId) {
    var vid = String(parentVariantId);
    return {
      _warranty_for: vid,
      _warranty_parent_variant: vid,
      _warranty_percentage: String(spec.pct || 15),
      _warranty_parent_sku: spec.sku || ""
    };
  }

  function addWarrantyLine(spec, parent) {
    return addCartItem({
      id: Number(spec.variantId),
      quantity: Number(parent.quantity || spec.qty || 1),
      properties: warrantyProperties(spec, parent.variant_id)
    });
  }

  function itemIndex(cart, item) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === item.key) return i;
    }
    return -1;
  }

  function ensureParentAboveWarranty(cart, parent, warranty) {
    if (!parent || !warranty) return Promise.resolve(cart);
    var parentAt = itemIndex(cart, parent);
    var warrantyAt = itemIndex(cart, warranty);
    if (parentAt !== -1 && warrantyAt !== -1 && parentAt < warrantyAt) return Promise.resolve(cart);
    var properties = parent.properties || {};
    return changeLineByKey(parent.key, 0).then(function () {
      return addCartItem({
        id: Number(parent.variant_id),
        quantity: Number(parent.quantity),
        properties: properties
      });
    }).then(fetchCart);
  }

  function syncWarrantyQty(cart) {
    var ops = [];
    (cart.items || []).forEach(function (item) {
      if (!isWarrantyItem(item)) return;
      var parent = findParentForWarranty(cart, item);
      if (!parent) ops.push({ key: item.key, qty: 0 });
      else if (item.quantity !== parent.quantity) ops.push({ key: item.key, qty: parent.quantity });
    });
    if (!ops.length) return Promise.resolve(cart);
    return ops.reduce(function (chain, op) {
      return chain.then(function () {
        return changeLineByKey(op.key, op.qty);
      });
    }, Promise.resolve()).then(fetchCart);
  }

  function paintVisibleCount(cart) {
    if (!cart) return;
    var n = 0;
    (cart.items || []).forEach(function (item) {
      if (!isWarrantyItem(item) && !isFeeItem(item)) n += Number(item.quantity) || 0;
    });
    document.querySelectorAll(".header__cart-count").forEach(function (el) {
      el.textContent = String(n);
      if (n < 1) el.setAttribute("hidden", "");
      else el.removeAttribute("hidden");
    });
    var mini = document.getElementById("mini-cart");
    if (mini) mini.setAttribute("data-item-count", String(n));
  }

  function toggleWarranty(box) {
    if (cartBusy) return;
    var spec = {
      variantId: box.getAttribute("data-warranty-variant-id"),
      parentKey: box.getAttribute("data-warranty-parent-key"),
      parentVariantId: box.getAttribute("data-warranty-parent-variant"),
      sku: box.getAttribute("data-warranty-parent-sku"),
      pct: box.getAttribute("data-warranty-pct"),
      qty: Number(box.getAttribute("data-warranty-qty") || 1)
    };
    cartBusy = true;
    fetchCart()
      .then(function (cart) {
        var parent = (cart.items || []).filter(function (item) {
          return item.key === spec.parentKey;
        })[0] || findParentByVariant(cart, spec.parentVariantId);
        var existing = parent ? findWarrantyFor(cart, parent) : null;
        if (box.checked) {
          if (!parent || !spec.variantId) return cart;
          if (existing) {
            if (existing.quantity === parent.quantity) {
              return ensureParentAboveWarranty(cart, parent, existing);
            }
            return changeLineByKey(existing.key, parent.quantity)
              .then(fetchCart)
              .then(function (next) {
                return ensureParentAboveWarranty(next, findParentByVariant(next, parent.variant_id), findWarrantyFor(next, parent));
              });
          }
          return addWarrantyLine(spec, parent)
            .then(fetchCart)
            .then(function (next) {
              var nextParent = findParentByVariant(next, parent.variant_id);
              return ensureParentAboveWarranty(next, nextParent, findWarrantyFor(next, nextParent || parent));
            });
        }
        if (existing) return changeLineByKey(existing.key, 0).then(fetchCart);
        return cart;
      })
      .then(syncServiceFee)
      .then(function (cart) {
        cartBusy = false;
        paintVisibleCount(cart);
        refreshCart();
      })
      .catch(function () {
        cartBusy = false;
      });
  }

  function inspectFee(cart, variantId, threshold) {
    var goods = 0;
    var feeLines = [];
    (cart.items || []).forEach(function (item) {
      if (Number(item.variant_id) === variantId || isFeeItem(item)) {
        feeLines.push({ item: item, key: item.key });
      } else {
        goods += Number(item.final_line_price) || 0;
      }
    });
    return {
      goods: goods,
      feeLines: feeLines,
      shouldHaveFee: goods > 0 && goods < threshold
    };
  }

  function removeFeeLines(lines) {
    return lines.reduce(function (chain, line) {
      return chain.then(function () {
        return changeLineByKey(line.key, 0);
      });
    }, Promise.resolve());
  }

  function collapseFeeLines(cart, variantId, threshold) {
    var state = inspectFee(cart, variantId, threshold);
    if (!state.shouldHaveFee) {
      if (!state.feeLines.length) return Promise.resolve(cart);
      return removeFeeLines(state.feeLines).then(fetchCart);
    }
    if (!state.feeLines.length) return Promise.resolve(cart);
    var keep = state.feeLines[0];
    var extras = state.feeLines.slice(1);
    var chain = removeFeeLines(extras);
    if (Number(keep.item.quantity) !== 1) {
      chain = chain.then(function () {
        return changeLineByKey(keep.key, 1);
      });
    }
    return extras.length || Number(keep.item.quantity) !== 1 ? chain.then(fetchCart) : Promise.resolve(cart);
  }

  function applyServiceFeeOnce(cart) {
    var cfg = parseFeeConfig();
    if (!cfg || !cfg.variantId) return Promise.resolve(cart);
    var variantId = Number(cfg.variantId);
    var threshold = Number(cfg.threshold) || 2500;
    var state = inspectFee(cart, variantId, threshold);
    if (!state.shouldHaveFee) {
      if (!state.feeLines.length) return Promise.resolve(cart);
      return removeFeeLines(state.feeLines).then(fetchCart);
    }
    var ready =
      state.feeLines.length === 1 && Number(state.feeLines[0].item.quantity) === 1;
    if (ready && feeIsLast(cart)) return Promise.resolve(cart);
    var chain = ready
      ? Promise.resolve(cart)
      : state.feeLines.length
        ? collapseFeeLines(cart, variantId, threshold)
        : addFeeVariant(variantId)
            .then(fetchCart)
            .then(function (next) {
              return collapseFeeLines(next, variantId, threshold);
            });
    return chain.then(ensureFeeLast);
  }

  function feeIsCorrect(cart) {
    var cfg = parseFeeConfig();
    if (!cfg || !cfg.variantId) return true;
    var state = inspectFee(cart, Number(cfg.variantId), Number(cfg.threshold) || 2500);
    if (!state.shouldHaveFee) return state.feeLines.length === 0;
    return (
      state.feeLines.length === 1 &&
      Number(state.feeLines[0].item.quantity) === 1 &&
      feeIsLast(cart)
    );
  }

  function syncServiceFee() {
    var run = feeSyncTail.then(function () {
      return fetchCart().then(applyServiceFeeOnce);
    });
    feeSyncTail = run.then(
      function () {},
      function () {}
    );
    return run;
  }

  function feeErrorText() {
    var cfg = parseFeeConfig();
    return (cfg && cfg.error) || "";
  }

  function showFeeError() {
    var message = feeErrorText();
    document.querySelectorAll("[data-cart-fee-error]").forEach(function (el) {
      el.hidden = !message;
      el.textContent = message;
    });
  }

  function hideFeeError() {
    document.querySelectorAll("[data-cart-fee-error]").forEach(function (el) {
      el.hidden = true;
    });
  }

  function setCheckoutButtonsBusy(busy) {
    document.querySelectorAll('[name="checkout"]').forEach(function (button) {
      button.disabled = busy;
      button.classList.toggle("is-disabled", busy);
      if (busy) button.setAttribute("aria-busy", "true");
      else button.removeAttribute("aria-busy");
    });
  }

  function goToNativeCheckout() {
    checkoutLeaving = true;
    clarityEvent("checkout_proceed");
    window.location.href = cartRoot() + "checkout";
  }

  function guardCheckout(event, form) {
    if (checkoutLeaving) return false;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (document.querySelector("[data-cart-stock-block]")) return true;
    if (blockCheckoutWithoutTerms(event, form)) return true;
    if (checkoutBusy) return true;
    checkoutBusy = true;
    cartBusy = true;
    hideFeeError();
    setCheckoutButtonsBusy(true);
    syncServiceFee()
      .then(function (cart) {
        if (feeIsCorrect(cart)) return cart;
        return syncServiceFee();
      })
      .then(function (cart) {
        if (!feeIsCorrect(cart)) throw new Error("service fee not applied");
        goToNativeCheckout();
      })
      .catch(function () {
        checkoutBusy = false;
        cartBusy = false;
        setCheckoutButtonsBusy(false);
        showFeeError();
        clarityEvent("fee_sync_failed");
        refreshCart();
      });
    return true;
  }

  function cartSig(cart) {
    return (cart.items || [])
      .map(function (item) {
        return item.key + ":" + item.quantity + ":" + item.variant_id;
      })
      .join("|");
  }

  function syncCartExtras() {
    if (cartBusy) return;
    cartBusy = true;
    fetchCart()
      .then(function (start) {
        var before = cartSig(start);
        return syncWarrantyQty(start)
          .then(syncServiceFee)
          .then(function (end) {
            cartBusy = false;
            paintVisibleCount(end);
            if (end && cartSig(end) !== before) refreshCart();
          });
      })
      .catch(function () {
        cartBusy = false;
      });
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function changeLineQty(line, qty) {
    return fetch(cartRoot() + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(function (response) {
      if (!response.ok) throw new Error("cart change failed");
      return response.json();
    });
  }

  var DISCOUNT_ATTR = "_emk_discount_code";

  function copyCartAttributes(cart) {
    var attributes = {};
    var existing = (cart && cart.attributes) || {};
    Object.keys(existing).forEach(function (key) {
      attributes[key] = existing[key];
    });
    return attributes;
  }

  function updateCartDiscount(normalized, attributes) {
    return fetch(cartRoot() + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ discount: normalized, attributes: attributes })
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) {
          var message = body.description || body.message || "error";
          throw new Error(message);
        }
        return body;
      });
    });
  }

  function discountForm() {
    return document.querySelector("[data-cart-discount]");
  }

  function validateDiscountCode(code) {
    var form = discountForm();
    var validateUrl = form && form.getAttribute("data-validate-url");
    if (!validateUrl) return Promise.reject(new Error("invalid"));
    return fetch(validateUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ code: code })
    }).then(function (response) {
      if (!response.ok) throw new Error("validate failed");
      return response.json();
    });
  }

  function applyDiscount(code) {
    var normalized = String(code || "").trim();
    return fetchCart().then(function (cart) {
      var attributes = copyCartAttributes(cart);
      if (!normalized) {
        attributes[DISCOUNT_ATTR] = "";
        return updateCartDiscount("", attributes);
      }
      return validateDiscountCode(normalized).then(function (result) {
        if (!result || !result.exists || result.active === false) {
          throw new Error("invalid");
        }
        attributes[DISCOUNT_ATTR] = normalized;
        return updateCartDiscount(normalized, attributes);
      });
    });
  }

  var discountReconciled = false;

  function reconcileStoredDiscount() {
    if (discountReconciled) return;
    var form = discountForm();
    if (!form || !form.getAttribute("data-validate-url")) return;
    discountReconciled = true;
    fetchCart()
      .then(function (cart) {
        var stored = cart && cart.attributes && cart.attributes[DISCOUNT_ATTR];
        if (!stored) return null;
        return validateDiscountCode(stored).then(function (result) {
          if (!result || !result.exists || result.active === false) {
            return applyDiscount("");
          }
          return null;
        });
      })
      .then(function (cleared) {
        if (cleared) refreshCart();
      })
      .catch(function () {});
  }

  function showDiscountError(root, message) {
    var el = root.querySelector("[data-cart-discount-error]");
    if (!el) return;
    el.hidden = false;
    el.textContent = message;
  }

  document.addEventListener(
    "click",
    function (event) {
      var buy = event.target.closest("buy-button");
      if (!buy) return;
      var box = document.querySelector("[data-warranty-pdp]");
      if (!box || !box.checked) return;
      if (pdpWarrantyPreAdded) {
        pdpWarrantyPreAdded = false;
        return;
      }
      var form = buy.closest("form");
      var idInput = form && form.querySelector('[name="id"]');
      var qtyInput = form && form.querySelector('[name="quantity"]');
      var parentVariantId = (idInput && idInput.value) || box.getAttribute("data-warranty-parent-variant");
      var spec = {
        variantId: box.getAttribute("data-warranty-variant-id"),
        sku: box.getAttribute("data-warranty-parent-sku"),
        pct: box.getAttribute("data-warranty-pct"),
        qty: qtyInput ? Number(qtyInput.value || 1) : 1
      };
      if (!spec.variantId || !parentVariantId) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var button = buy.querySelector("button") || event.target;
      button.setAttribute("disabled", "disabled");
      document.dispatchEvent(new CustomEvent("theme:loading:start"));
      fetchCart()
        .then(function (cart) {
          var existing = findWarrantyFor(cart, { key: "", variant_id: parentVariantId });
          if (existing) return cart;
          return addCartItem({
            id: Number(spec.variantId),
            quantity: spec.qty,
            properties: warrantyProperties(spec, parentVariantId)
          });
        })
        .then(function () {
          pdpWarrantyPreAdded = true;
          button.removeAttribute("disabled");
          button.click();
        })
        .catch(function () {
          pdpWarrantyPreAdded = true;
          button.removeAttribute("disabled");
          button.click();
        });
    },
    true
  );

  document.addEventListener("click", function (event) {
    var addBtn = event.target.closest("[data-action='ad-add']");
    if (addBtn) {
      event.preventDefault();
      var line = Number(addBtn.getAttribute("data-line"));
      var add = Number(addBtn.getAttribute("data-add"));
      var payload = parseAdPayload();
      var current = payload && payload.lines.find(function (item) { return item.line === line; });
      if (!current) return;
      changeLineQty(line, current.qty + add).then(refreshCart).catch(function () {});
      return;
    }

    var applyBtn = event.target.closest("[data-action='apply-discount']");
    if (applyBtn) {
      event.preventDefault();
      var form = applyBtn.closest("[data-cart-discount]");
      var input = form && form.querySelector("[data-cart-discount-input]");
      var code = input ? String(input.value || "").trim() : "";
      if (!code) return;
      applyDiscount(code)
        .then(function () {
          clarityEvent("discount_applied");
          refreshCart();
        })
        .catch(function () {
          clarityEvent("discount_rejected");
          var fallback = (form && form.getAttribute("data-invalid")) || "";
          showDiscountError(form, fallback);
        });
      return;
    }

    var clearBtn = event.target.closest("[data-action='clear-discount']");
    if (clearBtn) {
      event.preventDefault();
      applyDiscount("").then(refreshCart).catch(function () {});
      return;
    }

    var termsLink = event.target.closest("[data-cart-terms] a");
    if (termsLink) event.stopPropagation();

    if (event.target.closest(".mini-cart__line-item--fee, .line-item--fee, .line-item--fee-note, .cart-fee-line, .mini-cart__line-item--warranty, .line-item--warranty")) {
      var qtyAction = event.target.closest("[data-action='decrease-quantity'], [data-action='increase-quantity']");
      if (qtyAction) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }

  });

  document.addEventListener(
    "click",
    function (event) {
      var checkoutBtn = event.target.closest && event.target.closest('[name="checkout"]');
      if (!checkoutBtn) return;
      guardCheckout(event, checkoutBtn.closest("form"));
    },
    true
  );

  document.addEventListener("change", function (event) {
    var warrantyBox = event.target.closest("[data-warranty-toggle]");
    if (warrantyBox) {
      toggleWarranty(warrantyBox);
      return;
    }
    var input = event.target.closest("[data-cart-terms-input]");
    if (!input) return;
    persistTerms(input.checked);
    if (input.checked) hideTermsError(termsRoot(input));
  });

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      var submitter = event.submitter;
      var isCheckout = (submitter && submitter.name === "checkout") || form.querySelector('[name="checkout"]');
      if (!isCheckout) return;
      guardCheckout(event, form);
    },
    true
  );

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter") return;
    var input = event.target.closest("[data-cart-discount-input]");
    if (!input) return;
    event.preventDefault();
    var form = input.closest("[data-cart-discount]");
    var button = form && form.querySelector("[data-action='apply-discount']");
    if (button) button.click();
  });

  function init() {
    renderAdPrompts();
    blockCheckoutIfOversold();
    restoreTerms();
    syncCartExtras();
    watchStickyMenu();
    document.querySelectorAll("[data-cart-discount]").forEach(function (form) {
      form.setAttribute("data-invalid", form.getAttribute("data-invalid") || "");
    });
    reconcileStoredDiscount();
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("theme:loading:end", init);
})();

(function fitMiniCartToViewport() {
  var MIN = 180;
  var ticking = false;

  function isPhone() {
    return window.matchMedia("screen and (max-width: 640px)").matches;
  }

  function measure() {
    var header = document.querySelector(".header");
    var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    var gap = isPhone() ? 56 : 14;
    var max = Math.floor(window.innerHeight - headerBottom - gap);
    if (!isFinite(max) || max < MIN) max = MIN;
    document.documentElement.style.setProperty("--mini-cart-max-height", max + "px");
  }

  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      measure();
    });
  }

  function bindCart() {
    var cart = document.getElementById("mini-cart");
    if (!cart || cart.getAttribute("data-emk-fit-bound")) return;
    cart.setAttribute("data-emk-fit-bound", "1");
    if (window.MutationObserver) {
      new MutationObserver(measure).observe(cart, {
        attributes: true,
        attributeFilter: ["aria-hidden", "data-item-count"]
      });
    }
  }

  window.addEventListener("resize", onScrollOrResize);
  window.addEventListener("scroll", onScrollOrResize, { passive: true });
  document.addEventListener("DOMContentLoaded", function () {
    measure();
    bindCart();
  });
  document.addEventListener("theme:loading:end", function () {
    measure();
    bindCart();
  });
  measure();
  bindCart();
})();
